import React, { useState, useRef } from 'react';
import { Container, Spinner, Modal, ModalBody } from 'reactstrap';
import { ChevronLeft, UploadCloud, X, FileText } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { uploadAiKnowledgeBaseFiles } from '../ReduxToolkit/Reducers/aiKnowledgeBase';

const TRAINING_MODES = [
  { id: 'Append', label: 'Add to Existing knowledge' },
  { id: 'Replace', label: 'Replace Existing Knowledge' },
];

const ACCEPTED_TYPES = '.pdf,.doc,.docx,.csv,.txt';

function formatFileSize(bytes) {
  if (!bytes) return '0 kb';
  if (bytes < 1024) return `${bytes} b`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} kb`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} mb`;
}

function TrainVionne() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { uploadLoading } = useSelector((state) => state.aiKnowledgeBase);

  const fileInputRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [trainingMode, setTrainingMode] = useState('Append');
  const [isDragOver, setIsDragOver] = useState(false);
  const [trainingModal, setTrainingModal] = useState(false);
  const [filesError, setFilesError] = useState('');

  const handleBrowseClick = () => {
    fileInputRef.current?.click();
  };

  const addFiles = (newFiles) => {
    const fileArray = Array.from(newFiles);
    setFiles((prev) => {
      const existingNames = new Set(prev.map((f) => f.name));
      const unique = fileArray.filter((f) => !existingNames.has(f.name));
      return [...prev, ...unique];
    });
    setFilesError('');
  };

  const handleFileInputChange = (e) => {
    if (e.target.files?.length) {
      addFiles(e.target.files);
      e.target.value = '';
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    if (e.dataTransfer.files?.length) {
      addFiles(e.dataTransfer.files);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const removeFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleStartTraining = async () => {
    if (files.length === 0) {
      setFilesError('Please upload at least one file before starting training.');
      return;
    }
    setFilesError('');
    const result = await dispatch(uploadAiKnowledgeBaseFiles(files, trainingMode));
    if (result?.statusCode === 200) {
      setTrainingModal(true);
    }
  };

  const handleTrainingModalClose = () => {
    setTrainingModal(false);
    navigate('/ai-knowledge-base');
  };

  return (
    <div className="page-body" style={{ backgroundColor: '#f4f4f4', minHeight: '100vh' }}>
      <Container style={{ maxWidth: '800px', paddingTop: '40px', paddingBottom: '60px' }}>

        {/* Header */}
        <div className="mb-4">
          <button
            onClick={() => navigate('/ai-knowledge-base')}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              color: '#212121',
              marginBottom: '6px',
            }}
          >
            <ChevronLeft size={20} strokeWidth={2} />
            <span style={{ fontSize: '20px', fontWeight: '500' }}>
              Upload Documetnets To Train Vionne
            </span>
          </button>
          <p style={{ color: '#6c757d', fontSize: '13px', marginLeft: '26px', marginBottom: 0 }}>
            Upload documents to train the Smart Search Agent.
          </p>
        </div>

        {/* Card */}
        <div
          style={{
            background: '#fff',
            borderRadius: '20px',
            padding: '25px',
          }}
        >
          {/* Drag & Drop Zone */}
          <div
            onClick={handleBrowseClick}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            style={{
              border: `2px dashed ${isDragOver ? '#0d6efd' : '#d0d0d0'}`,
              borderRadius: '20px',
              padding: '40px 20px',
              textAlign: 'center',
              cursor: 'pointer',
              backgroundColor: isDragOver ? '#f0f7ff' : '#fafafa',
              transition: 'all 0.2s ease',
              marginBottom: '24px',
            }}
          >
            <input
              ref={fileInputRef}
              type="file"
              multiple
              accept={ACCEPTED_TYPES}
              onChange={handleFileInputChange}
              style={{ display: 'none' }}
            />
            <UploadCloud
              size={36}
              color={isDragOver ? '#0d6efd' : '#555'}
              strokeWidth={1.5}
              style={{ marginBottom: '12px' }}
            />
            <p style={{ fontWeight: '600', fontSize: '14px', color: '#212121', marginBottom: '4px' }}>
              Drag & Drop files here
            </p>
            <p style={{ fontSize: '13px', color: '#6c757d', marginBottom: '4px' }}>
              or click to browse
            </p>
            <p style={{ fontSize: '12px', color: '#9e9e9e', marginBottom: 0 }}>
              PDF, Doc, CSV, TXT
            </p>
          </div>

          {filesError && (
            <p style={{ color: '#dc3545', fontSize: '13px', marginTop: '-16px', marginBottom: '16px' }}>
              {filesError}
            </p>
          )}

          {/* Uploaded Files List */}
          {files.length > 0 && (
            <div style={{ marginBottom: '28px' }}>
              <p style={{ fontWeight: '500', fontSize: '14px', color: '#212121', marginBottom: '12px' }}>
                Uploaded Files
              </p>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {files.map((file, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      border: '1px solid #e8e8e8',
                      borderRadius: '8px',
                      padding: '8px 12px',
                      backgroundColor: '#fafafa',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, overflow: 'hidden' }}>
                      <div
                        style={{
                          width: '32px',
                          height: '32px',
                          borderRadius: '6px',
                          backgroundColor: '#f0f0f0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          flexShrink: 0,
                        }}
                      >
                        <FileText size={16} color="#555" strokeWidth={1.5} />
                      </div>
                      <div style={{ overflow: 'hidden' }}>
                        <p
                          style={{
                            margin: 0,
                            fontSize: '13px',
                            fontWeight: '500',
                            color: '#212121',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                        >
                          {file.name}
                        </p>
                        <p style={{ margin: 0, fontSize: '11px', color: '#9e9e9e' }}>
                          {formatFileSize(file.size)}
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={(e) => { e.stopPropagation(); removeFile(idx); }}
                      style={{
                        background: '#e0e0e0',
                        border: 'none',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        flexShrink: 0,
                        marginLeft: '12px',
                      }}
                    >
                      <X size={12} color="#555" strokeWidth={2.5} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Divider */}
          <hr style={{ borderColor: '#D9D9D9', margin: '0 0 24px 0' }} />

          {/* Training Configuration */}
          <div>
            <p style={{ fontWeight: '500', fontSize: '14px', color: '#212121', marginBottom: '16px' }}>
              Training Configuration
            </p>
            <div style={{ marginBottom: '24px' }}>
              <label style={{ fontSize: '13px', color: '#6c757d', marginBottom: '8px', display: 'block' }}>
                Training Mode
              </label>
              <div style={{ position: 'relative' }}>
                <select
                  value={trainingMode}
                  onChange={(e) => setTrainingMode(e.target.value)}
                  style={{
                    width: '100%',
                    padding: '10px 36px 10px 14px',
                    fontSize: '14px',
                    color: '#212121',
                    border: '1px solid #d0d0d0',
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                    appearance: 'none',
                    cursor: 'pointer',
                    outline: 'none',
                  }}
                >
                  {TRAINING_MODES.map((mode) => (
                    <option key={mode.id} value={mode.id}>
                      {mode.label}
                    </option>
                  ))}
                </select>
                <div
                  style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    pointerEvents: 'none',
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>
              </div>
            </div>
          </div>

          {/* Start Training Button */}
          {files.length > 0 && (
            <div className='d-flex justify-content-center'>
              <button
                onClick={handleStartTraining}
                disabled={uploadLoading}
                style={{
                  width: '50%',
                  padding: '14px',
                  backgroundColor: uploadLoading ? '#555' : '#212121',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '15px',
                  fontWeight: '600',
                  cursor: uploadLoading ? 'not-allowed' : 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  transition: 'background-color 0.2s ease',
                }}
              >
                {uploadLoading && <Spinner size="sm" />}
                {uploadLoading ? 'Uploading...' : 'Start Training'}
              </button>
            </div>
          )}
        </div>
      </Container>

      {/* Training in Progress Modal */}
      <Modal
        isOpen={trainingModal}
        toggle={handleTrainingModalClose}
        centered
        style={{ maxWidth: '380px', borderRadius: '20px' }}
      >
        <ModalBody style={{ padding: '36px 32px', textAlign: 'center', position: 'relative', borderRadius: '20px' }}>
          <button
            onClick={handleTrainingModalClose}
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <X size={18} color="#555" strokeWidth={2} />
          </button>

          {/* Documents icon */}
          <div
            style={{
              width: '64px',
              height: '64px',
              margin: '0 auto 20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="6" y="4" width="28" height="36" rx="3" fill="#e0e0e0" />
              <rect x="4" y="2" width="28" height="36" rx="3" fill="#bdbdbd" />
              <rect x="2" y="0" width="28" height="36" rx="3" fill="#9e9e9e" />
              <rect x="8" y="10" width="16" height="2" rx="1" fill="#fff" />
              <rect x="8" y="15" width="12" height="2" rx="1" fill="#fff" />
              <rect x="8" y="20" width="14" height="2" rx="1" fill="#fff" />
            </svg>
          </div>

          <h5 style={{ fontWeight: '700', fontSize: '17px', color: '#212121', marginBottom: '12px' }}>
            Training in Progress
          </h5>
          <p style={{ fontSize: '13px', color: '#6c757d', lineHeight: '1.6', marginBottom: 0 }}>
            This process may take a few minutes depending on file size and content volume. we'll notify you once training is complete.
          </p>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default TrainVionne;
